import { render, staticRenderFns } from "./UIkit.vue?vue&type=template&id=754bb7dc&scoped=true&"
import script from "./UIkit.vue?vue&type=script&lang=js&"
export * from "./UIkit.vue?vue&type=script&lang=js&"
import style0 from "./UIkit.vue?vue&type=style&index=0&id=754bb7dc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754bb7dc",
  null
  
)

export default component.exports